module.exports = __webpack_public_path__ + "img/Microsoft-Account.5aa06288.svg";